import { Modal } from "react-blueprint-library";
import NavigationButtons from "../../SharedComponents/NavigationButtons";

export default function EducationRequirementsModal({
  closeBackModal = () => {},
  backClick = () => {},
  isOpen = false,
}) {
  return (
    <>
      <div>
        <div id="eduReqModal"></div>
        <div>
          <Modal id="eduReqModal" show={isOpen} className="modal-md" title="">
            <div className="modal-body">
              <div className="container">
                <div className="row">
                  <div className="col-md-12">
                    <div className="modal-header">
                      <h2>Education Requirements Not Met</h2>
                      <div className="modal-close-button-wrapper">
                        <button
                          type="button"
                          className="close"
                          data-dismiss="modal"
                          aria-label="Close modal dialog"
                          onClick={closeBackModal}
                        />
                      </div>
                    </div>
                  </div>
                </div>
                <div className="row">
                  <div className="col-md-12">
                    <p style={{ fontSize: "1.4rem" }}>
                      Based on your answers, we cannot move you forward in the
                      application. Please notify your Agency so they can contact
                      you about next steps.
                    </p>
                  </div>
                </div>
                <NavigationButtons
                  onBack={closeBackModal}
                  onNext={backClick}
                  isLoading={false}
                  nxtbtnid={"exit-btn"}
                  nextBtnText="Exit Application"
                  bckbtnid={"cancel-btn"}
                  backBtnText="Cancel"
                  reverseBtnOrder={true}
                />
              </div>
            </div>
          </Modal>
        </div>
      </div>
    </>
  );
}
